module.exports = __webpack_public_path__ + "img/file.6cdd3494.svg";